import React from "react";
import FormControl from "@/components/FormControl/FormControl";
import type {
  Control,
  FieldValues,
  UseFormRegister,
  UseFormStateReturn,
} from "react-hook-form";
type FormFieldConfig = {
  controlType: string;
  label: string;
  placeholder?: string;
  validations?: Record<string, any>;
  isRequired?: boolean;
  autoComplete?: string;
  isControlled?: boolean;
  props?: Record<string, any>;
  hide?: boolean;
  parentName?: string;
};

type FormConfig = Record<string, FormFieldConfig>;
export default function formRenderer<TFieldValues extends FieldValues>(
  formConfig: FormConfig,
  formState: UseFormStateReturn<TFieldValues>,
  register: UseFormRegister<TFieldValues>,
  control?: Control<TFieldValues>,
  parentName?: string,
) {
  return Object.entries(formConfig || {}).map(([name, obj]) => {
    if (obj?.hide) return;
    const fieldName = parentName ? `${parentName}.${name}` : name;
    return (
      <FormControl
        key={fieldName}
        name={fieldName}
        controlType={obj.controlType}
        label={obj.label}
        placeholder={
          obj.placeholder || `Enter ${obj.label?.toLocaleLowerCase()}`
        }
        validations={obj.validations}
        errorMessage={
          fieldName
            .split(".")
            .reduce((acc: any, key) => acc?.[key], formState?.errors)?.message
        }
        isRequired={obj.isRequired}
        autoComplete={obj.autoComplete || "new-password"}
        {...(obj.isControlled && control ? { control } : { register })}
        {...(obj.props || {})}
      />
    );
  });
}
